export default {
  methods: {
    // 赠送配件订单专用
    // 跳转合同详情
    toContractDetail(row) {
      this.jump('/contractdetail', { contractId: row.orderId, contractClass: row.orderType, parentPath: this.$route.path });
    },

    infoChangeHandler() {
      if (this.getTableList) {
        this.getTableList();
      }
    },
  },

  computed: {
    // 是否为总部（工厂）
    isHq() {
      const userInfo = this.$store.state.userInfo || {};
      return userInfo.bizType === 'HQ';
    },

    // 是否为售后公司（兼容SC 和 JV_SC）
    isAfterService() {
      const userInfo = this.$store.state.userInfo || {};
      const arr = ['SC', 'JV_SC'];
      return arr.includes(userInfo.bizType);
    },
  },
};
